import { render, staticRenderFns } from "./NewsDeccanCronicle.vue?vue&type=template&id=039eba2c&scoped=true&"
import script from "./NewsDeccanCronicle.vue?vue&type=script&lang=js&"
export * from "./NewsDeccanCronicle.vue?vue&type=script&lang=js&"
import style0 from "./NewsDeccanCronicle.vue?vue&type=style&index=0&id=039eba2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039eba2c",
  null
  
)

export default component.exports